import { render, staticRenderFns } from "./playground_component.vue?vue&type=template&id=b7176cb8&"
import script from "./playground_component.vue?vue&type=script&lang=js&"
export * from "./playground_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7176cb8')) {
      api.createRecord('b7176cb8', component.options)
    } else {
      api.reload('b7176cb8', component.options)
    }
    module.hot.accept("./playground_component.vue?vue&type=template&id=b7176cb8&", function () {
      api.rerender('b7176cb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/playground_component.vue"
export default component.exports